import { http } from '@/http';

export default {
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        fetchMember() {
            return http.get("/active-trader/members/me")
                .then(res => res.data)
                .catch(err => {
                    console.error(err.message);
                    throw err;
                });
        },
        logout() {
            return http.get("/active-trader/members/logout")
                .then(res => res.data)
                .catch(err => {
                    console.error(err.message);
                    throw err;
                });
        }
    }
};